import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { default as SM } from 'scrollmonitor';
import FailIcon from './image_fail_icon.svg';
import Img from 'components/common/Img';
import { getMediaPath } from 'utils/environment';

class ImgLoader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loaded: false,
			reveal: false,
			status: null,
		}
		this.el = React.createRef();
		this.progressBar = React.createRef();
	}
	componentDidMount() {
		this.preloader = new Image();
		this.preloader.addEventListener('load', this.onload);
		this.preloader.addEventListener('error', this.onerror);
		this.preloader.src = getMediaPath( this.props.src );
	}
	componentWillUnmount() {
		this.destroyPreloader();
		this.destroyScrollMonitor();
		this.deactivateProgressBar();
	}
	onload = (e) => {
		this.setState({ loaded: true, status: 'success' });
		this.destroyPreloader();
		if ( this.props.wait ) { this.monitorScroll(); } else { this.reveal(); }
		if ( this.props.onload ) this.props.onload(e);
	}
	onerror = (e) => {
		this.setState({ loaded: false, status: 'error' })
		this.destroyPreloader();
		if ( this.props.wait ) { this.monitorScroll(); } else { this.kill(); }
		if ( this.props.onerror ) this.props.onerror(e);
	}
	ontransitionend = (e) => {
		this.deactivateProgressBar();
		if ( this.props.ontransitionend ) this.props.ontransitionend(e);
	}
	monitorScroll = () => {
		if ( !this.sm ) {
			const todo = (this.state.status === 'error')? this.kill : this.reveal;
			this.sm = SM.create( this.el.current );
			this.sm.enterViewport( todo );
		}
	}
	reveal = () => {
		this.destroyScrollMonitor();
		this.progressBar.current.addEventListener('transitionend', this.ontransitionend);
		this.setState({ reveal: true });
	}
	kill = () => {
		this.destroyScrollMonitor();
	}
	destroyPreloader = () => {
		if (this.preloader) {
			this.preloader.removeEventListener('load', this.onload);
			this.preloader.removeEventListener('error', this.onerror);
			this.preloader.src = '';
			this.preloader = null;
		}
	}
	destroyScrollMonitor = () => {
		if (this.sm) { this.sm.destroy(); this.sm = null; }
	}
	deactivateProgressBar = () => {
		if (this.progressBar.current) { this.progressBar.current.removeEventListener('transitionend', this.ontransitionend); }
	}
	progressBarStyle = () => {
		const hex = this.props.hex || '#f9f9f9';
		if ( this.state.status === 'error' ) {
			return {
				position: 'absolute', zIndex: 2,
				top: 0, left: 0, height: '100%',
				width: '100%', opacity: 1,
				background: `${hex} url(${FailIcon}) no-repeat 50% 50%`,
				backgroundSize: '2em'
			}
		}
		switch ( this.props.transitionMode ) {
			case 'slide':
				return {
					position: 'absolute', zIndex: 2,
					transition: '400ms width 150ms',
					top: 0, left: 0, height: '100%',
					width: (this.state.reveal)? '0%' : '100%',
					backgroundColor: hex,
				}
			default: 
				return {
					position: 'absolute', zIndex: 2,
					transition: '200ms opacity',
					top: 0, left: 0, width: '100%', height: '100%',
					opacity: (this.state.reveal)? 0 : 1,
					backgroundColor: hex,
				}
		}
	}
	render() {
		const { alt, width, height, hex } = this.props;
		const loaderStyle = {
			position: 'relative',
			width: '100%', height: 0,
			paddingBottom: (height / width) * 100 + '%',
			backgroundColor: hex,
		}
		const imgStyle = { display: 'block', width: '100%', height: 'auto' }
		const progressBarStyle = this.progressBarStyle();
		const src = (this.state.loaded) ? this.props.src : null;
		let classes = ["ImgLoader"];
		classes.push( "aspect-" + getAspectRatio(width, height) )
		return (
			<div className={classes.join(" ")} style={loaderStyle} ref={this.el}>
				{ this.state.status === 'success' && <Img src={src} alt={alt} width={width} height={height} style={imgStyle} /> }
				<div ref={this.progressBar} className="ProgressBar" style={progressBarStyle}></div>
			</div>
		)
	}
}

const getAspectRatio = ( width, height ) => {
	const ratio = width / height;
	if ( ratio < 1) { 
		return 'portrait'; 
	} else if ( ratio > 1 ) { 
		return 'landscape'; 
	} else { 
		return 'square'; 
	}
}

ImgLoader.defaultProps = {
	transitionMode: 'fade', // 'slide', 'fade'
	wait: true, // true / false
	hex: '#f9f9f9', // color code
}
ImgLoader.propTypes = {
	transitionMode: PropTypes.string,
	wait: PropTypes.bool,
	src: PropTypes.string.isRequired,
	width: PropTypes.number.isRequired,
	height: PropTypes.number.isRequired,
	alt: PropTypes.string,
	hex: PropTypes.string,
	onload: PropTypes.func,
	onerror: PropTypes.func,
	ontransitionend: PropTypes.func,
}

export default ImgLoader;


// WEBPACK FOOTER //
// ./src/components/common/ImgLoader.jsx